<template>
<header class="relative z-50 bg-transparent" style="margin-top: -100px;height: 100px;">
  <nav class="bg-transparent" >
    <div class="max-w-8xl mx-auto text-white flex px-20 sm:px-36 lg:px-36">
     
      <div class="justify-left w-1/2 pt-8 inline-flex landing-social">
        <a class="pr-8">Facebook</a>
        <a>Instagram</a>
      </div>

      <div class="items-center h-16 w-1/2 pt-8 landing-contact">
        <div class="items-center ">
          <div class="poem-text w-full text-right float-right">
          <span class="pr-8">(604) 498-6388</span>  <span>13591 King George Blvd. Surrey, B.C. V3T 2V1</span>
            </div>
        </div>

       
      </div>
    </div>
  </nav>
</header>
</template>

<script>
export default {};
</script>

<style>
.landing-social a
{
font-family: avenirLight;
font-style: normal;
font-weight: normal;
font-size: 16px;
line-height: 20px;
/* identical to box height, or 125% */

letter-spacing: 0.02em;
}
.landing-contact span
{
font-family: Times;
font-style: normal;
font-weight: normal;
font-size: 1rem;
line-height: 36px;
/* identical to box height, or 150% */

letter-spacing: 0.05em;
text-transform: uppercase;
}


</style>